import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Star } from 'lucide-react';
export function FinalCTA() {
  return <section className="py-8 sm:py-14 bg-[#111827] relative overflow-hidden" data-id="element-38">
      {/* Background effects */}
      <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/stardust.png')] opacity-10" data-id="element-39" />
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full bg-gradient-to-b from-transparent to-[#0a0e17]/80" data-id="element-40" />

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-41">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="space-y-5 sm:space-y-8" data-id="element-42">
          <div className="flex justify-center gap-1 mb-6" data-id="element-43">
            {[1, 2, 3, 4, 5].map(star => <Star key={star} className="w-6 h-6 text-[#d4a853] fill-[#d4a853]" data-id="element-44" />)}
          </div>

          <h2 className="text-3xl md:text-5xl font-bold text-white leading-tight" data-id="element-45">
            Tu primera pieza profesional está a un clic de distancia
          </h2>

          <p className="text-lg sm:text-xl text-[#9ca3af] max-w-2xl mx-auto" data-id="element-46">
            Empezá hoy a crear muebles y objetos que parecen de galería, desde
            tu garage.
          </p>

          <div className="pt-4 sm:pt-8 pb-2 sm:pb-4" data-id="element-47">
            <a href="#precio" className="group relative inline-flex items-center justify-center px-10 py-5 text-xl font-bold text-[#0a0e17] transition-all duration-200 bg-[#d4a853] rounded-lg hover:bg-[#f59e0b] hover:scale-105 hover:shadow-[0_0_30px_rgba(212,168,83,0.6)]" data-id="element-48">
              <span data-id="element-49">QUIERO MI MÁSTER AHORA</span>
              <ArrowRight className="ml-3 w-6 h-6 group-hover:translate-x-1 transition-transform" data-id="element-50" />
            </a>
          </div>

          <p className="text-sm text-[#9ca3af]/60" data-id="element-51">
            Acceso inmediato • Pago seguro • Garantía de satisfacción
          </p>
        </motion.div>
      </div>
    </section>;
}